import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { ApprovalCenterItem } from "./approval-center-item.model";

export class ChaseRequest {
  requestType: string;
  status: string;
  isChaseAssign?: boolean;
  approvalItems: ApprovalCenterItem[];

  constructor(options: {
    requestType: string;
    status: string;
    isChaseAssign?: boolean;
    approvalItems: ApprovalCenterItem[];
  }) {
    this.requestType = options.requestType;
    this.status = options.status;
    this.isChaseAssign = options.isChaseAssign;
    this.approvalItems = ArrayHelper.clean(options.approvalItems);
  }
}
